/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import {
  getMaxUtilityUnit,
  getEnergyTotalUsagesAreasDetails,
  getUtilityUnit
} from '../../../shared/Utils/EnergyUsagesFloorViewDetailsUtils';
import { IDataTableColumn } from '../../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import { IEmaasEnergyUsageComponentDataArea } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import EmaasDetailBreakdownByFloor from './EmaasDetailBreakdownByFloor';
import {
  IBreakdownByFloor,
  IEnergyTotalUsagesAreasDetails
} from './IEnergyUsagesBreakdownProps';
import { getEnergyColumns } from '../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import { ApiContext } from '../../../../context/ApiContext';
import EmaasDetailBreakdownByFloorInfiniteScroll from './EmaasDetailBreakdownByFloorInfiniteScroll';

interface ITotalEmissionsSavingsByMeterDetailComponentProps {
  data: IEmaasEnergyUsageComponentDataArea;
  ActiveIndex?: number;
}

export const emaasEnergyUsagesFloorWiseBreakDownMeter = (
  props: ITotalEmissionsSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const { data } = props;
  const apiContext = useContext(ApiContext);
  const { userPreferedUnit } = apiContext;

  let fromUnit;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }

  fromUnit = userPreferedUnit as any;
  const {
    energyMeasurementUnit,
    breakdownByUtility,
    areaWiseAggregations
  } = data;
  const utilityUnit =
    props.ActiveIndex === 0
      ? {
          electric: energyMeasurementUnit,
          gas: energyMeasurementUnit,
          water: energyMeasurementUnit
        }
      : getUtilityUnit(breakdownByUtility);

  // const energyMaxUtilityUnit = getMaxUtilityUnit(
  //   areaWiseAggregations,
  //   utilityUnit
  // );
  const totalConsumeUtilitydetails = {
    areaWiseSavingdata: areaWiseAggregations,
    utilityUnit,
    convertfromunit: {
      electric: fromUnit //energyMeasurementUnit
    }
  };

  const Utilitydetails = getEnergyTotalUsagesAreasDetails(
    [totalConsumeUtilitydetails as IEnergyTotalUsagesAreasDetails],
    apiContext.showChangeWhenData
  );

  const columnDetails: IDataTableColumn[] = getEnergyColumns(
    t,
    data.subscriptionType
  );

  const breakDownByMeterProps = ({
    meterData: Utilitydetails,
    utilityMeasurementUnit: Utilitydetails[0]?.unit, //energyMeasurementUnit,
    columnDetails,
    energyMeasurementUnit: energyMeasurementUnit,
    sourceType:
      data.sourceType.toLowerCase() === 'all' ? 'all' : data.sourceType
  } as unknown) as IBreakdownByFloor;

  return (
    <div className="emaas-Metersaving-details-head">
      {apiContext.toggleSeparateApi ? (
        <EmaasDetailBreakdownByFloorInfiniteScroll {...breakDownByMeterProps} />
      ) : (
        <EmaasDetailBreakdownByFloor {...breakDownByMeterProps} />
      )}
    </div>
  );
};
export default memo(emaasEnergyUsagesFloorWiseBreakDownMeter);
